<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('compassion.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'main' }">{{ $t('compassion.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-nav pills fill>
          <b-nav-item :to="{ name: 'love-life-articles', params: { type: 'sutra' } }">護生文集</b-nav-item>
          <b-nav-item :to="{ name: 'love-life-resources', params: { type: 'calendar' } }" active>資源下載</b-nav-item>
        </b-nav>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-dropdown text="請選擇分類" class="m-2">
          <b-dropdown-item
            v-for="resource_type in resource_types"
            :to="{ name: 'love-life-resources', params: { type: resource_type.key } }"
          >{{ resource_type.label }}</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <calendar v-if="type == 'calendar'"></calendar>
    <audiovisual v-if="type == 'audiovisual'"></audiovisual>
    <cartoon v-if="type == 'cartoon'"></cartoon>
    <cookbook v-if="type == 'cookbook'"></cookbook>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { DropdownPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'

import Audiovisual from '@/views/love-life/resource/Audiovisual'
import Calendar from '@/views/love-life/resource/Calendar'
import Cartoon from '@/views/love-life/resource/Cartoon'
import Cookbook from '@/views/love-life/resource/Cookbook'
import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(DropdownPlugin)
Vue.use(NavPlugin)

export default {
  i18n,
  name: "resources",
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      resource_types: [
        { key: 'calendar', label: '護生月曆' },
        { key: 'audiovisual', label: '護生影音' },
        { key: 'cartoon', label: '護生圖畫' },
        // { key: 'cookbook', label: '護生素食譜' }
      ]
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    Audiovisual,
    Calendar,
    Cartoon,
    Cookbook
  },
  metaInfo() {
    return {
      title: this.$t('compassion.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>